
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDbYvCrRGPlWrBPN43dag4MOifflQugkY6kBKkRT3eYgMeta } from "C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/index/index.vue?macro=true";
import { default as indexMqVIMZEB9VcIVRjuYrA1MN8XTYmqomKi4Xk9Rj2linYMeta } from "C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/formaciones/index.vue?macro=true";
import { default as _91slug_93aO6Ai6Lg1nV6Jel3PicaxHWxjVixUFLgpnQ2OD5ys1EMeta } from "C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/formaciones/[slug].vue?macro=true";
import { default as indexjK3bHyZ9v39VBxrat7cj7tYZY_1r3hbr9RnaKV_bzaUMeta } from "C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/terminos-legales/index.vue?macro=true";
import { default as indexGUqCY20rmiubOMypZLj_45p63AzvQGQLHep1JgbkX3o6EMeta } from "C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/politica-de-privacidad/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/index/index.vue")
  },
  {
    name: "formaciones",
    path: "/formaciones",
    component: () => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/formaciones/index.vue")
  },
  {
    name: "formaciones-slug",
    path: "/formaciones/:slug()",
    component: () => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/formaciones/[slug].vue")
  },
  {
    name: "terminos-legales",
    path: "/terminos-legales",
    component: () => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/terminos-legales/index.vue")
  },
  {
    name: "politica-de-privacidad",
    path: "/politica-de-privacidad",
    component: () => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/pages/politica-de-privacidad/index.vue")
  }
]